import GridViewModel from '@/ViewModels/Controls/GridViewModel';
import ComponentManager from '@/Management/ComponentManager';
import { ICoreFrameGridViewModelParameters } from '#/DefaultViewExtensionInterfaces';

export default class CoreFrameGridViewModel extends GridViewModel {

    public height;

    public constructor(protected params: ICoreFrameGridViewModelParameters) {
        super(params);
    }

}

ComponentManager.setViewModel('CoreFrameGridViewModel', CoreFrameGridViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');